import {
  GameMap,
  MapTile,
  TileType,
  MAP_CONFIG,
  ATTRIBUTE_ZONE_TILES,
} from '../types/GameMap';

/**
 * マップを生成
 */
export function generateMap(): GameMap {
  const { WIDTH, HEIGHT } = MAP_CONFIG;
  const tiles: MapTile[][] = [];

  // 1. 基本地形生成（ランダム）
  for (let y = 0; y < HEIGHT; y++) {
    tiles[y] = [];
    for (let x = 0; x < WIDTH; x++) {
      const type = randomBaseTileType();
      tiles[y][x] = {
        x,
        y,
        type,
        npcs: [],
      };
    }
  }

  // 2. 特殊タイル配置
  placeTown(tiles, 1); // 町1箇所（中央）
  placeMountains(tiles, 10); // 山10箇所（障害物）
  placeAttributeZones(tiles, 2); // 各属性ゾーン2箇所ずつ（計12箇所）
  placeForbiddenZone(tiles); // 禁忌の地1箇所

  return { width: WIDTH, height: HEIGHT, tiles };
}

/**
 * ランダムな基本タイル生成
 */
function randomBaseTileType(): TileType {
  const rand = Math.random();
  if (rand < 0.5) return 'grass'; // 50% 草原
  if (rand < 0.8) return 'forest'; // 30% 森
  return 'water'; // 20% 水場
}

/**
 * 属性ゾーン配置
 * 各属性ゾーンを指定数ずつ配置
 */
function placeAttributeZones(tiles: MapTile[][], countEach: number): void {
  for (const zoneType of ATTRIBUTE_ZONE_TILES) {
    let placed = 0;
    let attempts = 0;
    const maxAttempts = 100;

    while (placed < countEach && attempts < maxAttempts) {
      const x = Math.floor(Math.random() * MAP_CONFIG.WIDTH);
      const y = Math.floor(Math.random() * MAP_CONFIG.HEIGHT);

      // 草原か森の場所に配置（町・山・他の属性ゾーン以外）
      if (tiles[y][x].type === 'grass' || tiles[y][x].type === 'forest') {
        tiles[y][x].type = zoneType;
        placed++;
      }
      attempts++;
    }
  }
}

/**
 * 町配置
 */
function placeTown(tiles: MapTile[][], count: number): void {
  // マップ中央付近に配置
  const centerX = Math.floor(MAP_CONFIG.WIDTH / 2);
  const centerY = Math.floor(MAP_CONFIG.HEIGHT / 2);
  tiles[centerY][centerX].type = 'town';
}

/**
 * 山配置（移動不可）
 */
function placeMountains(tiles: MapTile[][], count: number): void {
  let placed = 0;
  while (placed < count) {
    const x = Math.floor(Math.random() * MAP_CONFIG.WIDTH);
    const y = Math.floor(Math.random() * MAP_CONFIG.HEIGHT);

    // 町以外の場所に配置
    if (tiles[y][x].type !== 'town') {
      tiles[y][x].type = 'mountain';
      placed++;
    }
  }
}

/**
 * 禁忌の地配置（1箇所）
 * 禁忌カード獲得チャンスがある特殊ゾーン
 */
function placeForbiddenZone(tiles: MapTile[][]): void {
  let attempts = 0;
  const maxAttempts = 100;

  while (attempts < maxAttempts) {
    const x = Math.floor(Math.random() * MAP_CONFIG.WIDTH);
    const y = Math.floor(Math.random() * MAP_CONFIG.HEIGHT);

    // 草原か森の場所に配置（町・山・他の特殊ゾーン以外）
    if (tiles[y][x].type === 'grass' || tiles[y][x].type === 'forest') {
      tiles[y][x].type = 'forbidden_zone';
      return;
    }
    attempts++;
  }
}
